import {
  Store,
  MonitorSmartphone,
  Receipt,
  Wallet,
  FileCheck,
  Users,
  Tag,
  TicketPercent,
} from "lucide-react";
import { FaMoneyBill } from "react-icons/fa6";

export const GROUP_NAMES: Record<string, string> = {
  PLANEJAMENTO_COMERCIAL: "Planejamento Comercial",
  REMARCACAO_DE_PRECO: "Remarcação de Preço",
  RETAGUARDA_DE_LOJA: "Retaguarda de Loja",
  TI: "TI",
  FISCAL: "Fiscal",
  FINANCEIRO: "Financeiro",
  CONCILIACAO: "Conciliação",
  ADM: "ADM",
  CRM: "CRM",
  RECURSOS_HUMANOS: "RH",
  ETIQUETA_REMARCADOS: "Etiqueta Remarcados",
};

export const ROUTE_TITLES: Record<string, string> = {
  "/users": "Usuários",
  "/groups": "Grupos e Rotas",
};

export const GROUP_ICONS = {
  PLANEJAMENTO_COMERCIAL: <FaMoneyBill className="h-5 w-5" />,
  REMARCACAO_DE_PRECO: <TicketPercent className="h-5 w-5" />,
  RETAGUARDA_DE_LOJA: <Store className="h-5 w-5" />,
  TI: <MonitorSmartphone className="h-5 w-5" />,
  FISCAL: <Receipt className="h-5 w-5" />,
  FINANCEIRO: <Wallet className="h-5 w-5" />,
  CONCILIACAO: <FileCheck className="h-5 w-5" />,
  RECURSOS_HUMANOS: <Users className="h-5 w-5" />,
  ETIQUETA_REMARCADOS: <Tag className="h-5 w-5" />,
  DEFAULT: <Store className="h-5 w-5" />,
} as const;

export const GROUP_GRADIENTS = [
  "from-[#F5CB2B] to-amber-500",
  "from-[#F5CB2B] to-orange-400",
  "from-amber-400 to-[#F5CB2B]",
  "from-[#F5CB2B] to-yellow-500",
  "from-yellow-400 to-[#F5CB2B]",
  "from-yellow-400 to-[#F5CB2B]",
] as const;

export const GROUP_GRADIENT_MAP = {
  PLANEJAMENTO_COMERCIAL: GROUP_GRADIENTS[0],
  REMARCACAO_DE_PRECO: GROUP_GRADIENTS[3],
  RETAGUARDA_DE_LOJA: GROUP_GRADIENTS[1],
  TI: GROUP_GRADIENTS[2],
  FISCAL: GROUP_GRADIENTS[3],
  FINANCEIRO: GROUP_GRADIENTS[4],
  CONCILIACAO: GROUP_GRADIENTS[5],
  RECURSOS_HUMANOS: GROUP_GRADIENTS[0],
  ETIQUETA_REMARCADOS: GROUP_GRADIENTS[0],
} as const;
